import React, { useState, useEffect, useRef }       from "react";
import IconHealthInfo                               from 'assets/icons/HealthInfo-icon.svg';
import IconArrowDown                                from "assets/icons/expandAllIcon.svg";
import { Accordion, Card, Button }                  from "react-bootstrap";
import Spinner                                      from 'react-bootstrap/Spinner';

function AccordianNestleOmegaPlus({nestle_omega_plus}) {

  const isCancelled = useRef(false);
  const [meals, setMeals] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [lipidTests, setLipidTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const lipid_units = {
    ldl_value: {
      label: 'LDL Cholesterol',
      unit: 'mmol/L'
    },
    hdl_value: {
      label: 'HDL Cholesterol',
      unit: 'mmol/L'
    },
    triglyceride: {
      label: 'Triglyceride',
      unit: 'mmol/L'
    }
  }

  useEffect(() => {
    getNOPInfo();

    return () => {
      isCancelled.current = true;
    };
  }, []); // eslint-disable-line

  const getNOPInfo = () => {
    setLoading(true);
    setQuestions(nestle_omega_plus.questionnaire);
    setLipidTests(nestle_omega_plus.lipid_test || []);
    setMeals(nestle_omega_plus.meals_uploaded);
    setLoading(false);
  }

  function LipidDetails(lipid_result){
    return (
      <>
        {lipid_result.map((l,i) => (
          <div className="info-row" key={`lipid-details-${i}`}>
            <div className="label">{lipid_units[l.name].label} <small className={`lipid-level level-${l.level}`}>{l.level.toUpperCase()}</small></div>
            <div className="info">{`${l.value} ${lipid_units[l.name].unit}`} </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      <Card className="nop-info card-accordian">
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="2">
            <div className="header-title">
              <img src={IconHealthInfo} alt="icon-info-circle" className="title-icon"/>
              <div className="title">Nestle Omega Plus</div>
            </div>
            <div><img src={IconArrowDown} alt="icon-arrow-down"/></div>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="2">
          <Card.Body>
            {loading ? <div className="loader"><Spinner animation="border" className="spinner"/></div> : (
              <>
               {questions.map((q, i) => (
                 <div className="info-row" key={`quiz-${i}`}>
                  <div className="label" dangerouslySetInnerHTML={{__html: q.question}}/>
                  <div className="info">{q.answer}</div>
                </div>
               ))}
                <div className="info-row">
                  <div className="label">Number of meals uploaded</div>
                  <div className="info">{meals}</div>
                </div>
               <hr/>
                {lipidTests.map((l, i) => (
                  <div className="lipid-container" key={`lipid-${i}`}>
                    <h6>Lipid Profile Test {i+1}</h6>
                    {l.redeemed_at && l.lipid_profile.id ? (
                      LipidDetails(l.lipid_profile.results)
                    ) : <div> - </div>}
                    <hr/>
                  </div>
                ))}
              </>
            )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}

export default AccordianNestleOmegaPlus;
